import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { NgForm } from '@angular/forms/src/directives/ng_form';

@IonicPage()
@Component({
  selector: 'page-modal-super',
  templateUrl: 'modal-super.html',
})
export class ModalSuperPage {

  //#region Propiedades del controlador
  private readonly _contrasenia:string = "SUPER";
  public password:string = "";
  //#endregion

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl:ViewController) {
  }

  ionViewDidLoad() {  }

  //#region Métodos del controlador

  public Validar(form:NgForm):void{
    if (form.valid){
      if (this.password.trim().toUpperCase() == this._contrasenia){
        this.viewCtrl.dismiss(true);
      }
      else {
        this.viewCtrl.dismiss(false);
      }
    }
  }

  //#endregion
}



// WEBPACK FOOTER //
// ./src/pages/modal-super/modal-super.ts